import { render, staticRenderFns } from "./ManageArea.vue?vue&type=template&id=04911b2c&"
import script from "./ManageArea.vue?vue&type=script&lang=js&"
export * from "./ManageArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports